import React, { useRef, useEffect } from 'react';

function injectLoader({ publisherId }) {
  !(function (e, f, u, i) {
    if (!document.getElementById(i)) {
      e.async = 1;
      e.src = u;
      e.id = i;
      f.parentNode.insertBefore(e, f);
    }
  })(
    document.createElement('script'),
    document.getElementsByTagName('script')[0],
    `//cdn.taboola.com/libtrc/${publisherId}/loader.js`,
    'tb_loader_script'
  );
  if (window.performance && typeof window.performance.mark == 'function') {
    window.performance.mark('tbl_ic');
  }
}

function taboolaPush(taboolaObj) {
  try {
    window._taboola = window._taboola || [];
    window._taboola.push(taboolaObj);
  } catch (e) {
    console.error('[taboola-pub-react] taboolaPush: ', taboolaObj);
  }
}

export function TaboolaComponent({
                          publisherId,
                          canonicalUrl,
                          pageType,
                          mode,
                          containerId,
                          placement,
                          targetType = 'mix',
                          custSeg,
                        }) {
  if (!publisherId || !pageType || !mode || !placement) return null;

  const pagePointer = useRef();
  const defaultContainerId = `${mode}-${placement}`.split(' ').join('');

  useEffect(() => {
    injectLoader({ publisherId });
  }, []);

  useEffect(() => {
    if (pagePointer.current !== canonicalUrl) {
      // New browser page (client side navigation)
      taboolaPush({ notify: 'newPageLoad' });
      taboolaPush({ [pageType]: 'auto', url: canonicalUrl });
    } else {
      // New static page (fresh HTML from server)
      taboolaPush({ [pageType]: 'auto' });
    }

    // Mark as client side navigation
    pagePointer.current = canonicalUrl;

    taboolaPush({
      mode,
      container: containerId,
      placement,
      target_type: targetType,
      ...(custSeg ? {cust_seg: custSeg} : {})
    });

    taboolaPush({ flush: true });
  }, [canonicalUrl]);

  return <div id={containerId || defaultContainerId} />;
}

export default TaboolaComponent;
